import LinearProgress from '@mui/material/LinearProgress'
import { isNumber } from 'lodash'

interface LinearIndeterminateProps {
  status?: 'pending' | 'done' | 'failed' | string
  value?: number
  absolute?: boolean
}

/**
 * If the value prop is passed, return a determinate progress bar with the value prop as the value.
 * If the status prop is 'failed', return a determinate progress bar with the color prop set to 'error'.
 * Otherwise, return an indeterminate progress bar
 * @returns A LinearProgress component with a variant of determinate and a value of value.
 */
export default function LinearIndeterminate({ absolute, status, value }: LinearIndeterminateProps) {
  if (status === 'done' || !status) return null

  const sx = absolute ? { left: 0, position: 'absolute', top: 0, width: '100%' } : {}

  /**
   * If has value then change variant to determinate and set value
   */
  const overrides = isNumber(value) ? { value, variant: 'determinate' as const } : {}

  if (status === 'failed') {
    return <LinearProgress variant="determinate" color="error" value={100} sx={sx} />
  }

  return <LinearProgress {...overrides} sx={sx} />
}
